import React from 'react';
import {
  ButtonProps,
  OutlineButton,
  PrimaryButton,
  Typography,
} from 'glints-aries/es/@next';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { WhatsappVerificationStep } from '../../../../../WhatsappVerification/types';
import { useWhatsappVerificationContext } from '../../../../../WhatsappVerification/WhatsappVerificationContext/WhatsappVerificationContext';
import { FORM_ID } from '../../../consts';
import { StyledModalFooter } from './styles.sc';

interface InputNumberModalFooterProps {
  onClose?: () => void;
  closeButtonText?: MessageDescriptor;
  closeButtonProps?: Pick<ButtonProps, 'disabled'>;
}

export const InputNumberModalFooter = ({
  onClose,
  closeButtonText,
  closeButtonProps,
}: InputNumberModalFooterProps) => {
  const { loading } = useWhatsappVerificationContext();

  return (
    <StyledModalFooter>
      {closeButtonText && (
        <OutlineButton onClick={onClose} {...closeButtonProps}>
          <Typography variant="button">
            <FormattedMessage {...closeButtonText} />
          </Typography>
        </OutlineButton>
      )}
      <PrimaryButton
        type="submit"
        form={FORM_ID[WhatsappVerificationStep.InputNumber]}
        loading={loading}
        disabled={loading}
      >
        <Typography variant="button">
          <FormattedMessage
            id="interactive-send-verification-code"
            defaultMessage="Send Verification Code"
          />
        </Typography>
      </PrimaryButton>
    </StyledModalFooter>
  );
};
